import React from "react";
import { I18n } from "react-redux-i18n";
import cx from "classnames";
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "@common/components/modal";
import { FormControl } from "@common/components/form-control";

import { getTestAttributes } from "@common/utils/tests";
import { Button } from "@common/components/Button";
import { Flex } from "@common/components/Flex";
import { MODULE_NAME } from "@modules/fhq-design-tool/constants/shared";

import "./rename-questionnaire-management.styles.scss";

export type RenameQuestionnaireManagementProps = {
  onClose: () => void;
  onSubmit: (questionnaireName: string) => void;
  className?: string;
  defaultValue?: string;
};

export const RenameQuestionnaireManagement: React.FC<RenameQuestionnaireManagementProps> = (props) => {
  const { onClose, onSubmit, className, defaultValue } = props;

  const [value, setValue] = React.useState(defaultValue ?? "");

  const handleValueChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  }, []);

  const handleSubmit = React.useCallback(() => {
    onSubmit(value.trim());
  }, [onSubmit, value]);

  const disabledSubmitBtn = defaultValue === value || !Boolean(value.trim().length)

  return (
    <Modal
      show
      animation={false}
      backdrop="static"
      bsClass="bootstrap modal"
      onEscapeKeyDown={onClose}
      onHide={onClose}
      className={cx("FHQDesignToolRenameQuestionnaireManagement", className)}
    >
      <ModalHeader closeButton onHide={onClose}>
        <ModalTitle {...getTestAttributes(MODULE_NAME, "rename-questionnaire-management-modal-header")}>
          {I18n.t("Rename questionnaire")}
        </ModalTitle>
      </ModalHeader>
      <ModalBody className="FHQDesignToolRenameQuestionnaireManagement__body">
        <FormControl
          {...getTestAttributes(MODULE_NAME, "rename-questionnaire", "text-field")}
          type="text"
          value={value}
          onChange={handleValueChange}
        />
      </ModalBody>
      <ModalFooter>
        <Flex justify="flex-end" alignItems="center">
          <Button {...getTestAttributes(MODULE_NAME, "rename-questionnaire-management-cancel", "button")} onClick={onClose}>
            {I18n.t("Cancel")}
          </Button>
          <Button
            bsStyle="primary"
            onClick={handleSubmit}
            {...getTestAttributes(MODULE_NAME, "rename-questionnaire-management-submit", "button")}
            disabled={disabledSubmitBtn}
          >
            {I18n.t("OK")}
          </Button>
        </Flex>
      </ModalFooter>
    </Modal>
  );
};
